import { InsInsightOutcomeResponse } from '@plato/data/prisma';
import type { BadgeProps } from '@plato/ui-legacy/components/list-views/badge';
import { useTranslation } from 'react-i18next';

export function useInsightOutcomeResponseLabel(response: InsInsightOutcomeResponse): string | null {
    const { t } = useTranslation('insights');

    switch (response) {
        case InsInsightOutcomeResponse.INTERESTED:
            return t('insight_outcome__response_INTERESTED');
        case InsInsightOutcomeResponse.NO_NEED:
            return t('insight_outcome__response_NO_NEED');
        case InsInsightOutcomeResponse.BUYS_ELSEWHERE:
            return t('insight_outcome__response_BUYS_ELSEWHERE');
        // INCORRECT and NORMAL belong to NOT_RELEVANT outcomes which are not shown in the app.
        case InsInsightOutcomeResponse.INCORRECT:
        case InsInsightOutcomeResponse.NORMAL:
            return null;
    }
}

export function getInsightOutcomeStatusColor(response: InsInsightOutcomeResponse): BadgeProps['color'] {
    switch (response) {
        case InsInsightOutcomeResponse.INTERESTED:
            return 'blue';
        case InsInsightOutcomeResponse.BUYS_ELSEWHERE:
            return 'orange';
        case InsInsightOutcomeResponse.NO_NEED:
            return 'neutral';
    }
}
